export default {
  authorization: 'Кіру',
  registration: 'Тіркелу',
  by_phone_number: 'Телефон арқылы кіру',
  by_iin: 'ЖСН арқылы кіру',
  phone_number: 'Телефон нөмірі',
  iin: 'ЖСН',
  password: 'Құпия сөз',
  login: 'Кіру',
  forgot_password: 'Құпия сөзді ұмыттыңыз ба?',
  further: 'Келесі',
  send: 'Жіберу',
  sms_verification_cod: 'Смс растау коды',
  send_again: 'Қайтадан жіберу',
  seconds: 'секундтан кейін',
  send_code_again: 'Кодты қайтадан жіберу',
  incorrect_code: 'Қате код',
  name: 'Аты',
  surname: 'Тегі',
  middle_name: 'Әкесінің аты',
  date_birth: 'Туған күні',
  male: 'Еркек',
  female: 'Әйел',
  repeat_password: 'Құпия сөзді қайталаңыз',
  referral_code: 'Рефералдық код',
  i_agree: 'Қызмет көрсету шарттарымен келісемін',
  password_recovery: 'Құпия сөзді қалпына келтіру',
  by_phone: 'Телефон арқылы',
  by_email: 'Email арқылы',
  restore: 'Қалпына келтіру',
  bonuse: 'Бонустар',
  status: 'Мәртебе',
  main: 'Басты бет',
  about: 'Ломбард туралы',
  our_services: 'Біздің қызметтер',
  guide: 'Нұсқаулық',
  my_pawnshop: 'Менің ломбардым',
  settings: 'Параметрлер',
  bonuses: 'Бонустар',
  referral: 'Рефералдық',
  go_out: 'Шығу',
  russian_language: 'Орыс тілі',
  kazakh_language: 'Қазақ тілі',
  my_office: 'Менің кабинетім',
  your_town: 'Сіздің қала',
  no: 'Жоқ',
  yes: 'Иә',
  text_1: 'Кезекте тұрғың келмейді ме?',
  text_2: 'Онда біздің СЕЙФ ломбард қосымшасы дәл сен үшін!',
  almaty: 'Алматы',
  developed: 'Mars Studio әзірленген',
  seif: '2021 © ЖШС «Сейф-Ломбард»',
  contact_us: 'Бізбен байланысу',
  your_name: 'Сіздің есіміңіз',
  email_address: 'Электрондық поштаңыз',
  contact_number: 'Байланыс телефоныңыз',
  message_text: 'Хабарлама мәтіні',
  write_us: 'Бізге жазу',
  head_office: 'Бас кеңсе',
  text_3: 'Қазақстан Республикасы <br> Алматы қаласы Жароков 276В',
  renewal_text: 'Басқа адам үшін ұзарту',
  ticket_number: 'Кепілзаттық билеттің нөмірі',
  text_4: 'Сонымен қатар сіз кепілзаттық билетті ұзарту жасай аласыз:',
  mobile_app: 'мобильдік қосымша',
  telegram_bot: 'telegram бот',
  qiwi_terminals: 'Qiwi',
  kassa_24: 'Касса 24 терминалдары',
  ticket_number_2: 'Кепілзаттық билеттің №',
  date_issue: 'Берілген күні',
  maturity_date: 'Өтеу күні',
  credit_amount: 'Шағын несие сомасы',
  amount_fine: 'Айыппұл сомасы',
  parameters: 'Параметрлер',
  minimum: 'Кемінде',
  day: 'күнге',
  days_extension: 'Күндерге ұзарту',
  to_pay: 'Төлемге:',
  tg: 'тг',
  pay: 'Төлеу',
  about_safe: 'Сейф-Ломбард туралы',
  years: 'жыл',
  financial_market: 'қаржы нарығында',
  branches: 'бөлімше',
  all_over_Kazakhstan: 'бүкіл Қазақстан бойынша',
  clients: 'клиент',
  text_5: 'біз қиын кезеңде көмектескен',
  text_6:
    'Біздің ломбард өз клиенттеріне ыңғайлы болу үшін қолдан келгеннің бәрін жасайды',
  referral_system: 'рефералдық жүйе',
  loyalty_program: 'икемдік бағдарламасы',
  social: 'Біз әлеуметтік желілердеміз',
  news: 'Жаңалықтар',
  text_7:
    'Бізге түйіндемеңізді пошта арқылы жіберіңіз, біз оны міндетті түрде қарастырамыз',
  videos: 'Бейнероликтер',
  cooperation: 'Ынтымақтастық',
  text_8:
    'Сейф-Ломбард бірінші қабатта және қозғалысы жақсы жерлерде орналасқан коммерциялық үй-жайларды, екі жаққа да тиімді шарттарда жалға беру туралы ұсыныстарды қарастырады',
  text_9: 'Сіз үшін жауап пайдалы болды ма?',
  thanks_tip: 'Пікіріңіз үшін рахмет!',
  details: 'Толығырақ',
  contact: 'Байланысу',
  services: 'Қызметтер',
  to_contact_us: 'Бізбен байланысу',
  page: 'Бет',
  other_news: 'Басқа жаңалықтар',
  auto: 'Автокөлікті кепілге қою арқылы',
  fur_products: 'Тері бұйымдарын кепілге қою арқылы',
  jewelry: 'Зергерлік бұйымдарды кепілге қою арқылы',
  text_10: 'Беттің жоғарғы жағына өту үшін басыңыз',
  back_site: 'Сайтқа оралу',
  text_11: 'Рәсімдеу кезіңде несие сомасын улғайтуға арналған бонустар',
  text_12:
    'Несиелік тарихыңызға байланысты санат пен жинақталған бонустардың саны есептеледі. Қызметтерді пайдаланыңыз, бонустар алыңыз және несие алған кезде бағалауды жоғарылатыңыз',
  active: 'Белсенділер',
  all: 'Барлығы',
  text_13: 'Кепілзаттық билеттер тізімі бос',
  maturity_date: 'Өтеу күні',
  expired: 'Мерзімі өткен',
  days: 'Күн',
  extend: 'Ұзарту',
  back: 'Артқа',
  mortgaged_property: 'Шағын несие сомасы',
  prolongation: 'Ұзарту',
  use_SLT: 'SLT-ны пайдалану',
  to_pay: 'Төлемге',
  amount_payment: 'Төлем сомасы',
  vendor_comission: 'Төлем операторының комиссиясы',
  add_card: 'Картаны қосу',
  another_card: 'Басқа картамен',
  payment_successful: 'Төлем сәтті өтті',
  payment_failed: 'Төлем өткен жоқ',
  referral_system_2: 'Рефералдық жүйе',
  referral: 'Реферал',
  specify: 'Көрсету',
  text_14:
    'Рефералдық жүйені белсендіру үшін қосымшада тіркелген және өзінің рефералдық коды бар ломбард клиентінің кодын көрсету қажет немесе ломбард бөлімшесіне жүгіну қажет',
  text_15:
    'Досыңызға реферал кодын жіберіңіз – досыңыз тіркелген кезде жүйе белсендіріледі. Сіз ақша ала бастайсыз (SLT): <br /> төленген пайыз сомасынан кешбек аласыз: <br />  1-ші деңгей (сіздің несилеріңіз) - 10% <br /> 2-ші деңгей – (сіз шақырған адамдардан) - 5% <br /> 3-ші деңгей (2 деңгейдегі адамның шақырғандарынан) - 3% <br /> Осы ақша (SLT) арқылы Сіз пайыздарды төлей аласыз, бірақ төлем сомасының 50% аспауы керек',
  referral_code_changed: 'Сіздің рефералдық кодыңыз өзгертілді',
  city: 'Қала',
  gender: 'Жынысы',
  address_residence: 'Тұрғылықты мекен-жайы',
  pushkin: 'Пушкина 88',
  text_16:
    'Досыңызға реферал кодын жіберіңіз – досыңыз тіркелген кезде жүйе белсендіріледі. Сіз ақша ала бастайсыз (SLT)::</br> төленген пайыз сомасынан кешбек аласыз:</br>1-ші деңгей (сіздің несилеріңіз) - 10%</br>2-ші деңгей – (сіз шақырған адамдардан) - 5%</br>3-ші деңгей (2 деңгейдегі адамның шақырғандарынан) - 3%</br>Осы ақша (SLT) арқылы Сіз пайыздарды төлей аласыз, бірақ төлем сомасының 50% аспауы керек',
  change_password: 'Құпия сөзді өзгерту',
  current_password: 'Ағымдағы құпия сөз',
  new_password: 'Жаңа құпия сөз',
  re_new_password: 'Жаңа құпия сөзді қайталау',
  save: 'Сақтау',
  change_email: 'Email өзгерту',
  emai_changed: 'Сіздің еmail өзгертілді',
  password_changed: 'Сіздің құпия сөзіңіз өзгертілді',
  my: 'Менің',
  office: 'ломбардым',
  day_d: ' к.',
  search: 'Іздеу',
  new_email: 'Жаңа email',
  rollover_amount: 'Ұзарту сомасы',
  title_main: 'Сейф Ломбард',
  home_link:
    'Шағын қаржыландыру қызметін жүзеге асыру лицензиясы 02.21.0004.L от 10.03.2021 г.',
  about_link: 'Шағын несиелендіруді нормаға сәйкес реттеу',
  about_link2:
    'Шағын несие беру және ломбардтағы кепіл заттар туралы келісімшарттың стандартты талаптары (қосылу келісімшарты)',
  about_link3: 'Годовая финансовая отчетность за 2020 год (рус)',
  about_link4: 'Годовая финансовая отчетность за 2020 год (eng)',
  about_link5: 'Годовая финансовая отчетность за 2021 год (рус)',
  about_link6: 'Годовая финансовая отчетность за 2021 год (eng)',
  about_link7: 'Годовая финансовая отчетность за 2022 год (рус)',
  about_link8: 'Годовая финансовая отчетность за 2022 год (eng)'
}



// WEBPACK FOOTER //
// ./src/lang/kz.js